import { useState, useEffect } from 'react';
import { array, func, object } from 'prop-types';
import { AddIcon, DeleteIcon } from 'components/icons';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import sty from '../styles/SubTabs.module.css';

/**
 * @component SubTabHeader
 * @param { Object } props
 * @param { array } props.options
 * @param { object } props.isDisabled
 * @param { array } props.selected
 * @param { function } props.onOptions
 * @param { function } props.onAdd
 * @param { function } props.onDelete
 * @returns { JSX.Element }
 */
function SubTabHeader(props) {
	const [values, setValues] = useState([]);

	useEffect(() => {
		setValues(props.selected);
	}, [props.selected]);

	return (
		<section className={sty.subtabs_header_section}>
			<Autocomplete
				multiple
				fullWidth
				disableCloseOnSelect
				value={values}
				options={props.options}
				getOptionLabel={(option) => option.name}
				isOptionEqualToValue={(option, value) => option.id === value.id}
				onChange={(e, newValues) => props.onOptions(newValues)}
				renderOption={(props, option) => {
					return (
						<li {...props} key={option.id}>
							{option.name}
						</li>
					);
				}}
				renderInput={(params) => (
					<TextField
						{...params}
						label="Subtabs"
						variant="outlined"
						size="small"
						InputLabelProps={{ shrink: true }}
					/>
				)}
			/>
			<div className={sty.subtabs_header_tooltips}>
				<Tooltip arrow title="Add Subtab">
					<IconButton component="div" disabled={props.isDisabled.add} onClick={props.onAdd}>
						<AddIcon />
					</IconButton>
				</Tooltip>
				<Tooltip arrow title="Delete Subtab">
					<IconButton component="div" disabled={props.isDisabled.delete} onClick={props.onDelete}>
						<DeleteIcon />
					</IconButton>
				</Tooltip>
			</div>
		</section>
	);
}

SubTabHeader.propTypes = {
	options: array,
	isDisabled: object,
	selected: array,
	onOptions: func,
	onAdd: func,
	onDelete: func,
};

export default SubTabHeader;
